import { P, S, T } from '../../../styles/tokens';

interface NumListProps {
  items: string[];
}

export function NumList({ items }: NumListProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {items.map((item, index) => (
        <div key={index} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
          {/* badge: terraSoft bg + terraDark text — matches prototype TFNumList */}
          <div
            style={{
              width: 22, height: 22, borderRadius: 11,
              background: P.terraSoft, color: P.terraDark,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
              font: T.caption, fontWeight: 700, lineHeight: '22px',
            }}
          >
            {index + 1}
          </div>
          <div style={{ flex: 1, font: T.subhead, color: S.label, lineHeight: '22px' }}>
            {item}
          </div>
        </div>
      ))}
    </div>
  );
}
